import { Controller } from "@hotwired/stimulus";
import { createRoot } from "react-dom/client";
import React from "react";
const COMPONENTS = {
  DateRangePickerComponent: () => import("@/components/DateRangePickerComponent"),
  DashboardDistributionChart: () => import("@/components/dashboard/DistributionChart"),
  DashboardStageChart: () => import("@/components/dashboard/StageChart"),
  DashboardTimeRangeDataChart: () => import("@/components/dashboard/TimeRangeDataChart"),
};

export default class extends Controller {
  static values = {
    name: String,
    props: Object,
  };

  async connect() {
    const connectionToken = Symbol("react-component");
    this.connectionToken = connectionToken;

    const componentName = this.nameValue;
    const props = this.propsValue;

    const loadComponent = COMPONENTS[componentName];
    if (!loadComponent) {
      console.error(`Unknown component: ${componentName}`);
      return;
    }

    try {
      const module = await loadComponent();
      if (this.connectionToken !== connectionToken) {
        return;
      }

      const Component = module.default || module[componentName];
      if (!Component) {
        throw new Error(`Component export not found for ${componentName}`);
      }

      if (!this.root) {
        this.root = createRoot(this.element);
      }
      this.root.render(React.createElement(Component, props));
    } catch (error) {
      console.error(`Failed to load component ${componentName}:`, error);
    }
  }

  disconnect() {
    this.connectionToken = null;
    if (this.root) {
      this.root.unmount();
      this.root = null;
    }
  }
}
